var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreeteasyListingsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#035d99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#032765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03023f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.25297,
    y: 25.14136,
    width: 15.49399,
    height: 6.76922
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.37274,46.04595c-.06805.45386.07263.81244.44928,1.07111.18158.12256.21338.29498.21338.50836-.00458,3.4494-.00458,6.89886-.00458,10.34827v.3222h5.14233c0-1.28442,0-2.55981.00458-3.8443h1.65668v3.84888h5.13776v-.30414c0-3.32233.00909-6.64014-.01361-9.96246,0-.5083.08624-.91229.5083-1.21185.0636-.04535.14075-.1225.14075-.19055.00909-.39941.00458-.79883.00458-1.20282h-13.23492c0,.21338.02264.4176-.00452.61731ZM54.03418,53.14446h-1.60669v-1.93799h1.60669v1.93799ZM52.41833,47.97942h1.61127v1.93353h-1.61127v-1.93353ZM52.4093,54.57415c0-.05444.07715-.1452.11804-.1452.49469-.00909.99396-.00452,1.50226-.00452v1.96521c-.51288,0-1.01666.00458-1.52045-.00452-.03632,0-.09985-.08624-.09985-.13617-.00909-.55823-.00909-1.11652,0-1.6748ZM49.18683,47.97485h1.6203v1.93811h-1.6203v-1.93811ZM49.18683,51.20647h1.6203v1.93799h-1.6203v-1.93799ZM45.95984,47.97033h1.61121v1.93799h-1.61121v-1.93799ZM47.57104,51.2019v1.94257h-1.60669v-1.94257h1.60669ZM45.95984,54.44256h1.62024v1.93805h-1.62024v-1.93805Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.6236,28.52593v5.26129h-19.24725v-5.26129h-8.70233v46.3327h36.65198V28.52593h-8.70239ZM59.11749,60.79675c-2.93201,2.99554-5.91846,5.93665-8.8822,8.90039-.06354.06354-.09991.15436-.14984.23151-.03174-.02271-.06354-.04535-.09528-.06812v-5.23309c-.42212-.02728-.82605-.04541-1.22998-.08173-2.43274-.23145-4.62494-1.0802-6.55847-2.56891-2.62335-2.01971-4.29816-4.66577-4.85638-7.92914-.73529-4.28906.39941-8.06531,3.3949-11.23785,1.95166-2.06964,4.36627-3.33594,7.1712-3.77167,3.83521-.59454,7.3028.32227,10.30737,2.79584,2.44641,2.0152,3.97144,4.61133,4.46613,7.74304.68079,4.31177-.49927,8.09253-3.56744,11.21973Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreeteasyListingsScraper);
export default __webpack_public_path__ + "static/media/streeteasy-listings-scraper.926716578f4aa35206538f71f96e17bd.svg";
export { ForwardRef as ReactComponent };